import React from "react";
import Container from "../Components/Container";
import Background from "../Components/Background";
import Introduce from "../Components/Introduce";
import LinkArea from "../Components/LinkArea";

const Home = () => {
  return (
    <Container>
      <Introduce></Introduce>
      <LinkArea></LinkArea>
    </Container>
  );
};

export default Home;
